import PublikovanyTerminList from './PublikovanyTerminList';

export default PublikovanyTerminList;
